export const CATEGORY_ID = {
  mycart: 'mycart',
  myfavorites: 'myfavorites',
  sponsored: 'sponsored',
};
